module.exports = __webpack_public_path__ + "static/carousel-slide-08-a3ad4d77b89eaeae4a1523b801f1cc81.png";